var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 828.2 126",
    style: {
      enableBackground: "new 0 0 828.2 126"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#585856;}\n\t.st2{opacity:0.28;fill-rule:evenodd;clip-rule:evenodd;fill:#97C139;enable-background:new    ;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#97C01E;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#97C139;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.5,30.9l31.5,68.5h-16.8l-8.4-18.3h-26.1l-8.8,18.3h-11.2l32.7-68.5H217.5z M200.7,74.8h20.2l-10-21.7 L200.7,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.4,32.3h16.5v25.2l29.8-25.2h12.8l-33.6,28.4l42.6,38.7h-20l-31.6-28.8v28.8h-16.5V32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.1,32.3h25.2c4.4,0,8.2,0.5,11.4,1.4c3.3,0.9,6,2.2,8.1,3.8c2.2,1.6,3.8,3.6,4.9,5.8 c1.1,2.2,1.6,4.7,1.6,7.3c0,1.9-0.4,3.7-1.1,5.4c-0.7,1.7-1.8,3.3-3.1,4.7s-3,2.7-4.9,3.8c-1.9,1.1-4,2-6.3,2.7L394,99.4H376 l-22.5-30.3h-2.9v30.3h-16.5V32.3z M350.6,63.2h3.6c2,0,3.9-0.3,5.6-0.8c1.7-0.6,3.2-1.4,4.5-2.4c1.3-1,2.2-2.3,2.9-3.8 c0.7-1.5,1.1-3.2,1.1-5.1c0-1.8-0.3-3.4-0.8-4.9c-0.5-1.5-1.3-2.8-2.3-3.8c-1-1.1-2.1-1.9-3.5-2.5c-1.4-0.6-2.8-0.9-4.4-0.9h-6.7 V63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.6,100.9c-5.4,0-10.5-0.9-15.1-2.6s-8.7-4.2-12.2-7.4c-3.4-3.2-6.1-6.9-8.1-11.2c-2-4.3-2.9-9.1-2.9-14.3 c0-5.1,1-9.7,2.9-14c2-4.2,4.7-7.9,8.1-10.9c3.4-3,7.5-5.4,12.2-7.1s9.7-2.5,15.1-2.5s10.5,0.8,15.1,2.5c4.7,1.7,8.7,4.1,12.2,7.1 c3.4,3,6.2,6.7,8.1,10.9s3,8.8,3,13.8c0,3.6-0.4,6.9-1.3,10.1c-0.9,3.2-2.2,6-3.8,8.7c-1.7,2.6-3.6,5-5.9,7.1 c-2.3,2.1-4.9,3.8-7.7,5.3c-2.9,1.5-5.9,2.6-9.2,3.3C443.7,100.5,440.2,100.9,436.6,100.9z M436.6,95.2c3.3,0,6.2-0.8,8.7-2.3 c2.5-1.5,4.6-3.6,6.3-6.2c1.7-2.6,3-5.8,3.8-9.4c0.9-3.6,1.3-7.6,1.3-12c0-4.3-0.4-8.2-1.3-11.7c-0.9-3.5-2.2-6.6-3.8-9.1 c-1.7-2.5-3.8-4.5-6.3-5.9c-2.5-1.4-5.4-2.1-8.7-2.1c-3.3,0-6.2,0.7-8.7,2.1c-2.5,1.4-4.6,3.4-6.3,5.9c-1.7,2.5-3,5.6-3.8,9.1 c-0.9,3.5-1.3,7.4-1.3,11.7c0,4.3,0.4,8.3,1.3,12c0.9,3.6,2.1,6.8,3.8,9.4c1.7,2.6,3.8,4.7,6.3,6.2 C430.4,94.5,433.3,95.2,436.6,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.7,32.3V38h-23.2v61.4h-16.4V38h-23.3v-5.7H546.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594,100.9c-5.4,0-10.5-0.9-15.1-2.6s-8.7-4.2-12.2-7.4s-6.1-6.9-8.1-11.2s-2.9-9.1-2.9-14.3 c0-5.1,1-9.7,2.9-14c2-4.2,4.7-7.9,8.1-10.9c3.4-3,7.5-5.4,12.2-7.1s9.7-2.5,15.1-2.5s10.5,0.8,15.1,2.5c4.7,1.7,8.7,4.1,12.2,7.1 c3.4,3,6.2,6.7,8.1,10.9s3,8.8,3,13.8c0,3.6-0.4,6.9-1.3,10.1c-0.9,3.2-2.2,6-3.8,8.7c-1.7,2.6-3.6,5-5.9,7.1 c-2.3,2.1-4.9,3.8-7.7,5.3c-2.9,1.5-5.9,2.6-9.2,3.3C601,100.5,597.6,100.9,594,100.9z M594,95.2c3.3,0,6.2-0.8,8.7-2.3 c2.5-1.5,4.6-3.6,6.3-6.2c1.7-2.6,3-5.8,3.8-9.4c0.9-3.6,1.3-7.6,1.3-12c0-4.3-0.4-8.2-1.3-11.7c-0.9-3.5-2.2-6.6-3.8-9.1 c-1.7-2.5-3.8-4.5-6.3-5.9c-2.5-1.4-5.4-2.1-8.7-2.1c-3.3,0-6.2,0.7-8.7,2.1c-2.5,1.4-4.6,3.4-6.3,5.9c-1.7,2.5-3,5.6-3.8,9.1 c-0.9,3.5-1.3,7.4-1.3,11.7c0,4.3,0.4,8.3,1.3,12c0.9,3.6,2.1,6.8,3.8,9.4c1.7,2.6,3.8,4.7,6.3,6.2C587.8,94.5,590.7,95.2,594,95.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M647.1,32.3h10.5L696,74.9V32.3h10.3v68.1h-7.1l-41.6-47.1v46.1h-10.4V32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M768.3,99.4h-11.5l28.5-33.1l-25.6-34h18.2l17,22.7l19.6-22.7H826l-25.6,30l27.9,37.2h-18.2l-19.5-25.9 L768.3,99.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 63,
    cy: 63,
    r: 63
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.1,125.5c-11.7-1.4-22.4-6.1-31.2-13l27.1-8.6l4.8,1.7L55.1,125.5L55.1,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.2,109.3l23-8.1L5.1,87.9C8.6,96.1,13.8,103.3,20.2,109.3L20.2,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.8,81.5C1,75.8,0.1,69.7,0.1,63.3c0-2.5,0.2-5,0.4-7.5l28.4,33.4l0,0L2.8,81.5L2.8,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.5,50.2l14.8,16.2L42,60L6.7,35.4C4.3,40,2.6,45,1.5,50.2L1.5,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.7,30c3.5-5.5,7.8-10.4,12.8-14.6l4.9,26.3L9.7,30L9.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.5,11.8l6.3,33l0,0L57.3,61l0.8-24.2l-26.9-28C29.6,9.7,28,10.7,26.5,11.8L26.5,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.4,6c4.5-2.1,9.4-3.7,14.5-4.6l-5.3,13.5l0,0L36.4,6L36.4,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.9,0.8c1.5-0.2,3-0.3,4.5-0.4l-0.9,27l-9-8.7L54.9,0.8L54.9,0.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "57,70.4 56.1,97.3 40.2,92.6 40.2,92.6 19.7,70.1 19.7,70.1 48.6,64.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66,0.4c7,0.4,13.8,1.9,20,4.4l-6.8,30.7l-11.7,9l0,0l-0.4-11.3L66,0.4L66,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.2,6.2c5.1,2.5,9.9,5.7,14.1,9.4l-18,13.9L90.2,6.2L90.2,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.6,19.8L98,28.9l18.1,0.7C113.9,26,111.4,22.8,108.6,19.8L108.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.3,37.4c3.4,7.7,5.4,16.3,5.4,25.2l-26.4-3.7L120.3,37.4L120.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.6,67.8c-0.3,3.7-0.8,7.3-1.7,10.8l-18.7,7.6l11.6-19L125.6,67.8L125.6,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.7,86.8c-2.9,7.1-7,13.6-12.2,19.1l-17.8-4.6L120.7,86.8L120.7,86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.5,110.8l-21.1-5.4l-12.6,6.1l0.5,14.1C82.9,123.9,94.4,118.7,103.5,110.8L103.5,110.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "69.5,100.7 97.1,89.4 97.1,89.4 112.1,67 92.7,65.7 92.7,65.7 69.1,89.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68.7,77.6 68.7,77.6 114.6,34.7 90.7,35.1 67.9,54.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e42955697e22f4888050073e52f0a7c7.svg";
export { ForwardRef as ReactComponent };